import { useAuthStore } from '@sparkai/auth'
import { UserRoles } from '@sparkai/shared-types'
import { jwtDecode } from 'jwt-decode'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom-v5-compat'

export const TrainingModuleTask = () => {
  const { token, userProfile } = useAuthStore()
  const decodedToken = jwtDecode(token || '') as Record<string, string>
  const role = decodedToken['https://spark.ai/sparkai-role'] as UserRoles

  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const programId = searchParams.get('program-id')
  const trainingModuleId = searchParams.get('training-module-id')
  const operatorId = searchParams.get('operator-id')
  const engagementId = searchParams.get('engagement-id')
  const sessionId = searchParams.get('training-session')

  const origin = window.location.origin.includes('spark.local')
    ? 'https://spark.local'
    : window.location.origin

  useEffect(() => {
    let url = ''

    if (role === 'admin') {
      url = `${origin}/admin/specialists/${operatorId}/review/${trainingModuleId}/?engagementId=${engagementId}&sessionId=${sessionId}`
    } else if (userProfile?.app_user_id === operatorId) {
      url = `${origin}/ms/skills/${programId}/${trainingModuleId}/review/?engagementId=${engagementId}&sessionId=${sessionId}`
    } else if (role === 'customer') {
      url = `${origin}/customer/`
    } else {
      url = `${origin}/ms/`
    }

    window.location.href = url
  }, [
    engagementId,
    operatorId,
    origin,
    programId,
    role,
    sessionId,
    trainingModuleId,
    userProfile?.app_user_id,
  ])

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center bg-brand-gray-50 text-sm text-brand-gray-400'>
      Loading...
    </div>
  )
}
